import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ConciergeAPI from '../serviceAPI/ConciergeAPI';

const initialState = {
  conciergeData: [],
  isLoading: false,
  prevThumbnailDetails: null,
  prevThumbnailId: '',
  errorCode: null,
};

export const getConciergeData = createAsyncThunk(
  'getConciergeData',
  async (id, { rejectWithValue }) => {
    try {
      const res = await ConciergeAPI.GetConciergeData(id);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

export const createNewConciergeData = createAsyncThunk(
  'createNewConciergeData',
  async ({ newData, id }, { rejectWithValue }) => {
    try {
      const res = await ConciergeAPI.CreateNewConciergeData(newData, id);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

export const updateConcierge = createAsyncThunk(
  'updateConcierge',
  async ({ newData, id }, { rejectWithValue }) => {
    try {
      const res = await ConciergeAPI.UpdateConcierge(newData, id);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

export const deleteConcierge = createAsyncThunk(
  'deleteConcierge',
  async (id, { rejectWithValue }) => {
    try {
      const res = await ConciergeAPI.DeleteConcierge(id);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  }
);

const ConciergeSlice = createSlice({
  name: 'concierge',
  initialState,
  reducers: {
    setPrevThumbnailDetails: (state, action) => {
      state.prevThumbnailDetails = action.payload;
    },
    setPreThumbnailId: (state, action) => {
      state.prevThumbnailId = action.payload;
    },
    resetErrorAlert: (state, action) => {
      state.errorCode = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getConciergeData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getConciergeData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.conciergeData = action.payload;
      })
      .addCase(getConciergeData.rejected, (state, action) => {
        state.isLoading = false;
        state.errorCode = action.payload;
      })
      .addCase(createNewConciergeData.fulfilled, (state, action) => {
        state.conciergeData = action.payload;
      })
      .addCase(createNewConciergeData.rejected, (state, action) => {
        state.errorCode = action.payload;
      })
      .addCase(updateConcierge.fulfilled, (state, action) => {
        state.conciergeData = action.payload;
      })
      .addCase(updateConcierge.rejected, (state, action) => {
        state.errorCode = action.payload;
      })
      .addCase(deleteConcierge.fulfilled, (state) => {
        state.conciergeData = null;
      })
      .addCase(deleteConcierge.rejected, (state, action) => {
        state.errorCode = action.payload;
      });
  },
});

export const { setPrevThumbnailDetails, setPreThumbnailId, resetErrorAlert } =
  ConciergeSlice.actions;
export default ConciergeSlice.reducer;
